import { Box, Button } from "@mui/material";
import { isEmpty, omit } from "lodash";
import { useArbitrageFilters } from "src/Modules/Arbitrage/context";

interface Props {
  onCancel?: VoidFunction;
  onApply?: VoidFunction;
  editValue: any;
}

export const EditFilterActions = ({ onCancel, onApply, editValue }: Props) => {
  const {
    setCurrentEditFilter,
    currentEditFilter,
    setActiveFiltersByName,
    setIsMenuOpen,
  } = useArbitrageFilters();

  const handleApply = () => {
    !!currentEditFilter &&
      setActiveFiltersByName(
        (prev: any) => {
          const newValue = !isEmpty(editValue)
            ? {
                ...prev,
                [currentEditFilter.name]: editValue,
              }
            : omit(prev, currentEditFilter.name);

          return newValue;
        },
        currentEditFilter.name,
        editValue
      );

    setCurrentEditFilter(null);
    setIsMenuOpen(false);
  };

  return (
    <Box p="1rem 0" alignSelf="flex-end">
      <Button
        variant="outlined"
        size="small"
        onClick={() => onCancel ?? setCurrentEditFilter(null)}
      >
        Cancel
      </Button>
      <Button
        style={{ marginLeft: "0.5rem" }}
        variant="contained"
        size="small"
        onClick={onApply ?? handleApply}
      >
        Apply
      </Button>
    </Box>
  );
};
